import { render, staticRenderFns } from "./ManageRule.vue?vue&type=template&id=7bd9f492"
import script from "./ManageRule.vue?vue&type=script&lang=js"
export * from "./ManageRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports